import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteSubscriptionTeamMutation, deleteSubscriptionTeamMutationVariables } from '../generated/deleteSubscriptionTeamMutation';
import { subscriptionTeamFieldsFragment } from '../models/SubscriptionTeam';

/**
 * Get a callback to delete a SubscriptionTeam in the store.
 */
export function useDeleteSubscriptionTeamCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteSubscriptionTeamMutation, deleteSubscriptionTeamMutationVariables>(
        gql`
            mutation deleteSubscriptionTeamMutation ($id: ID!) {
                deleteSubscriptionTeam(id: $id) {
                    ...subscriptionTeamFields
                }
            }

            ${subscriptionTeamFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
